var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-item-module"
  }, [_c('h1', {
    staticClass: "module-title"
  }, [_vm._v("附件上传")]), _vm._v(" "), _c('attach', {
    ref: "attach",
    attrs: {
      "init": _vm.data,
      "rid": _vm.rid
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3efd6a8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/attachModule.vue
// module id = null
// module chunks = 